<template>
  <van-popup v-model="showPayPage" class="payRect" @closed="onClosed">
    <TopBar :pagetitle="data.title" :is-left-self="true" @leftClick="showPayPage=false" />
    <div class="fastRect">
      <FieldSelect v-model="payType" :list="columnsPayType" label="支付方式" placeholder="请选择支付方式" @change="onPayTypeChange" />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>产品</span></div>
        <div class="van-cell__value" style="text-align:left">{{ data.about }}</div>
      </div>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>价格</span></div>
        <div class="van-cell__value" style="text-align:left">￥{{ ShowMoney(data.price) }}</div>
      </div>

      <div v-if="payPoundage>0" class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>支付手续费</span></div>
        <div class="van-cell__value" style="text-align:left">￥{{ ShowMoney(data.price * payPoundage) }}<br>(更换支付方式无手续费)</div>
      </div>
    </div>
    <div class="downButton">
      <van-button type="danger" :color="GetColorMain()" style="width:100%" :loading="buttonLoading" @click="onPay">立即支付</van-button>
    </div>
  </van-popup>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Switch, Popup, Checkbox } from 'vant'
import TopBar from '@/components/TopBar'
import { GetEnumList, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import FieldSelect from '@/components/FieldSelect'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    TopBar,
    FieldSelect
  },
  props: {
    // eslint-disable-next-line
    dataObj:Object,
    // eslint-disable-next-line
    value: Boolean
  },
  data() {
    return {
      showPayPage: false,
      picId: undefined,
      columnsPayType: [],
      payType: undefined,
      buttonLoading: false,
      payPoundage: 0,
      data: {
        title: '支付',
        about: '',
        price: 0,
        isSystem: false
      }

    }
  },
  watch: {
    value(newValue) {
      this.showPayPage = newValue
      if (this.showPayPage) {
        // this.initType(this.data.isSystem)
      }
    },
    dataObj(newValue) {
      this.data = newValue
      this.initType(this.data.isSystem)
    }

  },
  created() {
  },
  methods: {
    GetEnumList,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    initType(isSystem) {
      this.columnsPayType = []
      request({
        url: '/Store/GetPAYChannel',
        method: 'post',
        data: {
          isSystem: isSystem
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.columnsPayType = Response.data
        this.columnsPayType.forEach(el => {
          el.text = el.name
          el.value = el.moneyChannelId
        })
        if (this.columnsPayType.length > 0) {
          this.onPayTypeChange(this.columnsPayType[0])
        }
      })
      // setTimeout(() => {

      // }, 1);
      // if (onlyOff) {
      //   setTimeout(() => {
      //     this.columnsPayType = GetEnumList('Em_PayType').filter(item => item.value === 'OFFLINE')
      //     console.log('this.columnsPayType onlyOff', this.columnsPayType)
      //   }, 1)
      //   setTimeout(() => {
      //     this.payType = 'OFFLINE'
      //   }, 2)
      // } else {
      //   setTimeout(() => {
      //     this.columnsPayType = GetEnumList('Em_PayType')
      //     console.log('this.columnsPayType', this.columnsPayType)
      //   }, 1)
      //   setTimeout(() => {
      //     this.payType = 'WECHAT_PAY'
      //   }, 2)
      // }
    },
    onClosed() {
      this.$emit('input', false)
    },
    onPay() {
      this.showPayPage = false
      this.$emit('onPay', this.payType)
      // this.buttonLoading = true
      // request({
      //   url: '/Pro/picPay',
      //   method: 'post',
      //   data: { picId: this.picId,
      //     payType: this.payType }
      // }).then(Response => {
      //   this.buttonLoading = false
      //   if (!Response.success) {
      //     return
      //   }
      //   this.$router.push('/store/pay/0?id=' + Response.data)
      // })
    },
    init(callback) {
      request({
        url: '/Pro/getPicById',
        method: 'post',
        params: { picId: this.picId }
      }).then(Response => {
        this.loading = true
        if (!Response.success) {
          return
        }
        this.data = Response.data
        if (callback) {
          callback()
        }
      })
    },
    getWechatPayPoundage() {
    },
    onPayTypeChange(select) {
      console.log('onPayTypeChange', select)
      this.payType = select.value
      this.payPoundage = select.chargesPercentage
      if (select.isFreePayPrice) {
        this.payPoundage = 0
      }
      this.payPoundage = 0 // 暂不开放
    }
  }
}
</script>
<style scoped>
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.downButton{
    position:fixed;
    left: 0;
    bottom:0;
    right: 0;
    height: 3em;
    border-top: 1px solid #f5f5f5;
}
.downButton button{
}
.payRect{
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
